import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Success.css';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Session ID validates successful payment
    if (!sessionId) {
      navigate('/pricing');
    }
  }, [sessionId, navigate]);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✅</div>
        <h1>Subscription Activated!</h1>
        <p className="success-message">
          Welcome to your premium experience! Your subscription has been successfully activated.
        </p>

        <div className="success-features">
          <h3>What's Next?</h3>
          <ul>
            <li>✓ Enjoy unlimited or expanded likes</li>
            <li>✓ See who liked you</li>
            <li>✓ Access advanced filters</li>
            <li>✓ Get enhanced profile visibility</li>
          </ul>
        </div>

        <div className="success-actions">
          <button
            className="primary-button"
            onClick={() => navigate('/browse')}
          >
            Start Browsing
          </button>
          <button
            className="secondary-button"
            onClick={() => navigate('/subscription')}
          >
            Manage Subscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
